import { useMutation, gql } from "@apollo/client"
import { ADMINABLE_USERS_FIELDS } from "./useQueryAdminableUsers"

const RESEND_INVITE_MUTATION = gql`
  ${ADMINABLE_USERS_FIELDS}
  mutation ResendInvite($id: ID!) {
    resendInvite(id: $id) {
      ...AdminableUsersFields
    }
  }
`

const useMutationResendInvite = () => useMutation(RESEND_INVITE_MUTATION)

export { useMutationResendInvite }
